var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 113,
    viewBox: "0 0 101 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4351 46.797C73.086 47.0715 66.9226 50.5916 66.9226 58.4186C66.9226 67.4719 74.7653 70.6748 75 70.7541C74.9639 70.9493 73.7541 75.1404 70.865 79.4108C68.2889 83.1688 65.5985 86.9207 61.5056 86.9207C57.4127 86.9207 56.3594 84.5109 51.6346 84.5109C47.0301 84.5109 45.393 87 41.6492 87C37.9054 87 35.2932 83.5227 32.2898 79.2522C28.8108 74.2375 26 66.447 26 59.0531C26 47.1935 33.6079 40.9038 41.0954 40.9038C45.0739 40.9038 48.3904 43.5515 50.8882 43.5515C53.2657 43.5515 56.9733 40.7452 61.4996 40.7452C63.215 40.7452 69.3783 40.9038 73.4351 46.797ZM59.3508 35.7244C61.2227 33.4732 62.5469 30.3497 62.5469 27.2262C62.5469 26.7931 62.5107 26.3538 62.4325 26C59.3869 26.1159 55.7635 28.0559 53.5787 30.6243C51.8633 32.6009 50.2623 35.7244 50.2623 38.8906C50.2623 39.3664 50.3405 39.8423 50.3766 39.9948C50.5692 40.0314 50.8822 40.0741 51.1952 40.0741C53.9278 40.0741 57.3646 38.2195 59.3508 35.7244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_701",
    x: 0.0500011,
    y: 0.0500011,
    width: 100.9,
    height: 112.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_701",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d2a28cabebe6989deb0408bc5c38995d.svg";
export { ForwardRef as ReactComponent };